import { buildCollection } from "@firecms/core";

export const headerStyleCollection = buildCollection({
  id: "header_style",
  name: "Header Style",
  path: "header_style",
  icon: "horizontal-split",
  group: "Style",
  textSearchEnabled: true,
  properties: {
    name: {
      dataType: "string",
      name: "Name",
      validation: {
        required: true,
      },
    },
    title_primary_padding_top: {
      dataType: "number",
      name: "Primary Title [Top Padding]",
      description: "Top padding in DIP",
      validation: {
        required: true,
        min: 0,
        integer: true,
      },
    },
    title_primary_padding_bottom: {
      dataType: "number",
      name: "Primary Title [Bottom Padding]",
      description: "Bottom padding in DIP",
      validation: {
        required: true,
        min: 0,
        integer: true,
      },
    },
    title_secondary_padding_bottom: {
      dataType: "number",
      name: "Primary Title [Bottom Padding]",
      description: "Bottom padding in DIP",
      validation: {
        min: 0,
        integer: true,
      },
    },
    title_primary: {
      dataType: "reference",

      name: "Title [Primary]",
      path: "title_style",
      validation: {
        required: true,
      },
    },
    title_secondary: {
      dataType: "reference",
      name: "Title [Secondary]",
      path: "title_style",
    },
  },
});
